import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token') || '',
    userInfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
    permissionMenuList: [],
    sidebarCollapse: false
  },
  mutations: {
    SET_MENU_PATH_MAP(state, map) {
      state.menuPathMap = map
    },
    SET_TOKEN(state, token) {
      state.token = token
      sessionStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      sessionStorage.setItem('userInfo', JSON.stringify(info))
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('userInfo')
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapse = !state.sidebarCollapse
    },
    SET_PERMISSION_MENU(state, menus) {
      state.permissionMenuList = menus
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userId: state => state.userInfo.userId || null,
    username: state => state.userInfo.username || '',
    roleIdList: state => state.userInfo.roleIdList || [],
    distributorId: state => state.userInfo.distributorId || null,
    parentId: state => state.userInfo.parentId || null,
    permCodes: state => state.userInfo.permCodes || []
  }
})
